import React, { useState } from 'react';

const images = [
  '/images/gallery/g1.jpeg',
  '/images/gallery/g2.jpeg',
  '/images/gallery/g3.jpeg',
  '/images/gallery/g4.jpg',
  '/images/gallery/g5.jpg',
  '/images/gallery/g6.jpg',
  '/images/gallery/g7.jpg',
];

const Gallery = () => {
  const [activeImage, setActiveImage] = useState(null);

  return (
    <section className="py-32 bg-white" id="gallery">
      <div className="max-w-8xl mx-auto px-8">

        {/* Header */}
        <div className="mb-24 text-center space-y-6">
          <h2 className="text-4xl md:text-5xl font-bold text-blue-900">
            Gallery
          </h2>
          <p className="text-xl md:text-2xl text-blue-800 max-w-4xl mx-auto leading-relaxed">
            Moments from our activities, events, and community outreach programs.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
          {images.map((src, index) => (
            <button
              key={index}
              onClick={() => setActiveImage(src)}
              className="group relative overflow-hidden rounded-2xl focus:outline-none"
            >
              <img
                src={src}
                alt={`Gallery ${index + 1}`}
                loading="lazy"
                decoding="async"
                className="h-80 w-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition" />
            </button>
          ))}
        </div>

        {/* Modal */}
        {activeImage && (
          <div
            className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-6"
            onClick={() => setActiveImage(null)}
          >
            <img
              src={activeImage}
              alt="Preview"
              className="max-h-[90vh] max-w-[90vw] rounded-xl"
            />
          </div>
        )}

      </div>
    </section>
  );
};

export default Gallery;
